module.exports = __webpack_public_path__ + "img/right02.d0251555.webp";